import React from 'react';
import Layout from '../../../components/global/Layout';
import Form from './Form';

const FoodOrderActivity = () => (
  <Layout>
    <Form />
  </Layout>
);

export default FoodOrderActivity;
